export default function () {
    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.5 7.34277V9.34277" stroke="#F8D492" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M12.5 7.34277V9.34277" stroke="#F8D492" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M16.5 7.34277V9.34277" stroke="#F8D492" strokeWidth="1.5" strokeLinecap="round" />
            <path
                d="M5 10.8428C5 10.2905 5.44772 9.84277 6 9.84277H19C19.5523 9.84277 20 10.2905 20 10.8428V19.8428H5V10.8428Z"
                stroke="url(#paint0_linear_1135_5224)"
                strokeWidth="1.5"
            />
            <path d="M3.5 19.8428H21.5" stroke="#CE9B59" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M8.5 13.8428H16.5" stroke="#E3B775" strokeWidth="1.5" strokeLinecap="round" />
            <path
                d="M9.25 5.09277C9.25 5.50699 8.91421 5.84277 8.5 5.84277C8.08579 5.84277 7.75 5.50699 7.75 5.09277C7.75 4.67856 8.08579 4.34277 8.5 4.34277C8.91421 4.34277 9.25 4.67856 9.25 5.09277Z"
                fill="#F9D694"
            />
            <path
                d="M13.25 5.09277C13.25 5.50699 12.9142 5.84277 12.5 5.84277C12.0858 5.84277 11.75 5.50699 11.75 5.09277C11.75 4.67856 12.0858 4.34277 12.5 4.34277C12.9142 4.34277 13.25 4.67856 13.25 5.09277Z"
                fill="#F9D694"
            />
            <path
                d="M17.25 5.09277C17.25 5.50699 16.9142 5.84277 16.5 5.84277C16.0858 5.84277 15.75 5.50699 15.75 5.09277C15.75 4.67856 16.0858 4.34277 16.5 4.34277C16.9142 4.34277 17.25 4.67856 17.25 5.09277Z"
                fill="#F9D694"
            />
            <defs>
                <linearGradient id="paint0_linear_1135_5224" x1="12.5" y1="9.84277" x2="12.5" y2="19.8428" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F7D391" />
                    <stop offset="1" stopColor="#C99452" />
                </linearGradient>
            </defs>
        </svg>
    );
}
